__turbopack_context__.v({
  "button": "InlineButton-module-scss-module__GDdbpW__button",
  "currentColor": "InlineButton-module-scss-module__GDdbpW__currentColor",
  "fade-in": "InlineButton-module-scss-module__GDdbpW__fade-in",
  "no-transform": "InlineButton-module-scss-module__GDdbpW__no-transform",
  "rotate": "InlineButton-module-scss-module__GDdbpW__rotate",
  "size-md": "InlineButton-module-scss-module__GDdbpW__size-md",
  "size-sm": "InlineButton-module-scss-module__GDdbpW__size-sm",
  "weightStrong": "InlineButton-module-scss-module__GDdbpW__weightStrong",
});
